import { createAsyncThunk } from '@reduxjs/toolkit'
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getUserData } from '../../utils/tools';
import { getAuthHeader,getAuthHeaderforimage } from '../../utils/tools';
import axios from 'axios';
import { updateCategories } from '../reducers/news';


import JSONBigInt from 'json-bigint'

//import { useSelector } from 'react-redux'



axios.defaults.headers.post['Content-Type'] = 'application/json';
const BASE_URL="https://backend.nativehelper.com/news/"


//const BASE_URL="http://localhost:8080/"
//const BASE_URL="http://192.168.1.5:8080/"
//http://103.117.180.14:8080/news/api/auth/signin

//const BASE_URL="http://103.117.180.14:8080/news/"


export const addNews = createAsyncThunk(
    'news/addNews',
    async(news,{ dispatch })=>{

        const newsData = {
            heading:news.heading,
             content:news.content,
             languageType:news.languageType,
             userId:getUserData().userId,
             userName:getUserData().userName,
             category:news.category,
             phNo:news.phNo,
             districtID:news.districtID,
             talukID:news.talukID
        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

           console.log("777777777777777777");
            console.log(newsData)

         console.log(newsData.heading)
          
         console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/news/add`,newsData,getAuthHeader());
            dispatch(successGlobal('News created !!'))
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

    
)



export const getAdminArticle = createAsyncThunk(
    'news/getAdminArticle',
    async(_id,{ dispatch })=>{
        
        try{
            const request = await axios.get(`${BASE_URL}api/news/getOfcNews/${_id}`,getAuthHeader());

           
            return request.data;
            
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)




export const updateNews = createAsyncThunk(
    'news/updateNews',
    async(news,{ dispatch })=>{

        const newsData = {
            newsID:news.newsID,
            heading:news.heading,
             languageType:news.languageType,
             userId:getUserData().userId,
             userName:getUserData().userName,
             category:news.category,
             phNo:news.phNo,
             //content:news.content,
             cntTrnNO:news.trnNO,
             districtID:news.districtID,
             talukID:news.talukID

        };
        const  customConfig = {
        headers: {
        'Content-Type': 'application/json',
        'Authorization':getAuthHeader().headers.Authorization
        
        }
    };


        try{

            console.log("777777777777777777");
           console.log(newsData)

           // console.log(newsData.heading)
          
         //   console.log("888888888888888888888");
           
            const request = await axios.post(`${BASE_URL}api/news/uheading`,newsData,getAuthHeader());
            dispatch(successGlobal('News update !!'))

            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           //createAsyncThunkonsole.log("1000000000000000000");
            console.log(error.response.data);
            //console.log("333333333333333333333");
            throw error
        }
    }

    
)

export const getPaginateArticles = createAsyncThunk(
    'news/getPaginateArticles',
    async({page=0,limit=10,keywords=''},{ dispatch })=>{
        try{
            const url=`${BASE_URL}api/news/tutorials?page=${page}&size=${limit}&sort=createdDate,desc`;
            console.log("333333333");

            console.log(page);
            console.log("333333333");

          //  http://localhost:8080/api/news/tutorials?page=0&size=20&sort=createdDate,desc&sort=newsHeading,asc
            const request = await axios.get(url,getAuthHeader()).then(
                console.log("12121212121"),
                (data) => console.log(data),
                console.log("12121212121"),
               
              );
            console.log("6666666");
            console.log(request);
            console.log("6666666");
            console.log(request.data);
            console.log("6666");

            let r1 = JSONBigInt.parse(request.request.response);
            let jsonStr=JSONBigInt.stringify(r1);
            const jsonStr1= jsonStr.replace(new RegExp('"newsID":([0-9]+),',"g"),'"newsID":"$1",')
             const ddd=JSON.parse(jsonStr1);
            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

export const homeLoadMore = createAsyncThunk(
    'news/homeLoadMore',
    async(sort,{ dispatch, getState })=>{
        
        try{
            
            //const url=`${BASE_URL}api/news/headlines/${getUserData().userId}/${sort.skip}/${sort.limit}`;
         
           let url="xyz";

           console.log("12121212233333");
           console.log(url);
           console.log("121212124444444");
           if(getUserData()===undefined){
            url=`${BASE_URL}api/online/headlines/1000000018/${sort.skip}/${sort.limit}`;
           }
           else{
            url=`${BASE_URL}api/news/headlines/${getUserData().userId}/${sort.skip}/${sort.limit}`;
           }
           // const url=`${BASE_URL}api/online/headlines/1000000018/${sort.skip}/${sort.limit}`;
            console.log("1111111111");
            console.log(url);
            console.log("111111111111111");
            let news = await axios.get(url,getAuthHeader()).then(
                console.log("12121212121"),
                (data) => console.log(news),
                console.log("12121212121"),
               
              );
              //JSONbigint.parse(news.data);
              console.log("6666666");
              console.log(getState());
            const state = getState().news.news;
            
            console.log("6666666");
            console.log(news.data.headLines);
            console.log("6666666");

             const prevState = [...state];
            const newState = [...prevState,...news.data.headLines]
            return { newState,sort }
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

export const getNews = createAsyncThunk(
    'news/getNews',
    async(id,{ dispatch })=>{

   
        
        //const url=`${BASE_URL}api/news/details/${id}/${getUserData().userId}`;
        
   


       let url="xyz";

        //    console.log("12121212233333");
        //    console.log(url);
        //    console.log("121212124444444");
           if(getUserData()===undefined){
            url=`${BASE_URL}api/online/details/${id}/1000000018`;
           }
           else{
            url=`${BASE_URL}api/news/details/${id}/${getUserData().userId}`;
           }
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
           
            
            return request.data.news;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)



//GETTING NEWS FOR OFFICE USE
export const getNewsofC = createAsyncThunk(
    'news/getNewsofC',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/news/detailsOfc/${id}/${getUserData().userId}`;
        
        
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                
               
              );
             // JSONbigint.parse(request.data);
           
            
            return request.data.news;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)


export const getNewsCategory = createAsyncThunk(
    'news/getNewsCategory',
    async(id,{ dispatch })=>{
        const url=`${BASE_URL}api/newscatgrs/catgrs`;

   
        try{
            const request = await axios.get(url,getAuthHeader()).then(
                //console.log("12121212121"),
                
                //console.log("12121212121"),
               
              );
             // JSONbigint.parse(request.data);
           // console.log("2222222222222");
           // console.log(request);
            //console.log("22222222222");
           // console.log(request.data.categories);
           // console.log("3333333333333");
            
            return request.data.categories;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }

        
    }
)
export const addCategory = createAsyncThunk(
    'news/addCategory',
    async(data,{ dispatch, getState })=>{
        try{
            const category = await axios.post('/api/articles/categories',data,getAuthHeader());
            const state = getState().articles.categories;

            const prevState = [...state];
            const newState = [...prevState,category.data]

            dispatch(updateCategories(newState));
            dispatch(successGlobal('Category created !!'))
            return newState;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

//UPLOAD NEWS IMAGES 
export const newImageUpload = createAsyncThunk(
    'news/newImageUpload',
    async(data,{ dispatch})=>{
        console.log("111111111111111111");
        const url=`${BASE_URL}uploadFile`;
        console.log(url);
        
        console.log(data);
        console.log("111111111111111111");
        try{
            const response = await axios.post(url,data,getAuthHeaderforimage()).then((response) => {
      // handle the response
      console.log("333333");
      console.log(response);
      console.log("444444444");
    })
           
            dispatch(successGlobal('Image is uploaded..!!'))
             return response;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


//GETTING IMAGE URLS FOR OFFICE USE 
export const getAdminImages = createAsyncThunk(
    'news/getAdminImages',
    async(_id,{ dispatch })=>{
        
        try{
            const request = await axios.get(`${BASE_URL}api/news/images/${_id}/${getUserData().userId}`,getAuthHeader());
            console.log("66666666666");
            console.log(request);
            console.log("666666$$$$$$$$$$$");
            console.log(request.data);
            console.log("666666$$$$$$$$$$$");
           
            return request.data;
            
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

//GETTING HEADER BASED ON STATUS VALUE
export const getPaginateArticlebyStatus = createAsyncThunk(
    'news/getPaginateArticlebyStatus',
    async({page=0,limit=10,status},{ dispatch })=>{
        try{
            const url=`${BASE_URL}api/news/status?page=${page}&size=${limit}&status=${status}&sort=createdDate,desc`;
            //const url=`${BASE_URL}api/news/headlines//${page}/${limit}/${status}`;
           // const url=`${BASE_URL}api/news/headlines//${page}/${limit}/5/PSD`;
            console.log("333333333777777");

            console.log(url);
            console.log("33333333377777");
           // http://localhost:8080/api/news/headlines/1000000000/0/5/2/ETD
           

          //  http://localhost:8080/api/news/tutorials?page=0&size=20&sort=createdDate,desc&sort=newsHeading,asc
        //     const request = await axios.get(url,getAuthHeader(),{ transformResponse: function(response) {
        //         return JSONbigint.parse(response.data);
        //   }}).then(


            const request = await axios.get(url,getAuthHeader(),{ transformResponse: (response) => {
                response.data = JSONBigInt.parse(response.data)
                return response
              }}).then(
                
                
               
               
               
              );
          
          
           let r1 = JSONBigInt.parse(request.request.response);
           let jsonStr=JSONBigInt.stringify(r1);
           const jsonStr1= jsonStr.replace(new RegExp('"newsID":([0-9]+),',"g"),'"newsID":"$1",')
            const ddd=JSON.parse(jsonStr1);
            
             
            return ddd;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)

export const imageStatusChange = createAsyncThunk(
    'news/imageStatusChange',
    async({data,addURL},{ dispatch})=>{
        
        try{
            const url=`${BASE_URL}${addURL}`;
            console.log("333333333");
            console.log(url);
        console.log(data);
        console.log("333333333");

            const category = await axios.post(url,data,getAuthHeader());
            

            console.log(url);
            if(category!=null)
            {
                console.log(category);
                console.log("333333333");
                

                if(category.data.message==="success"){
                    dispatch(successGlobal('success fully approved !!'))
                }
                else{
                    dispatch(errorGlobal('kindly check your status!!'))
                }
            }
        
            
            return category.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


export const headingStatusChange = createAsyncThunk(
    'news/headingStatusChange',
    async({data,addURL},{ dispatch})=>{
        
        try{
            const url=`${BASE_URL}${addURL}`;
            console.log("333333333");
            console.log(url);
        console.log(data);
        console.log("333333333");

            const category = await axios.post(url,data,getAuthHeader());
            

            console.log(url);
            if(category!=null)
            {
                console.log(category);
                console.log("333333333");
                

                if(category.data.message==="success"){
                    dispatch(successGlobal('success fully approved !!'))
                }
                else{
                    dispatch(errorGlobal('kindly check your status!!'))
                }
            }
        
            
            return category.data;
        } catch(error){
            
            dispatch(errorGlobal(error.response.data.message))
            throw error
        }
    }
)


//Update News Content
export const updateNewscontent = createAsyncThunk(
    'news/updateNewscontent',
    async(news,{ dispatch })=>{
     

        try{

            let myArray = news.id.split("_");
       
 
            let id1= Number(myArray[0]);
            let trns= Number(myArray[1]);

           

                         

                         const newsContent= {
   
                            newsId:id1,
                            transNo:trns,
                            content:news.content,
                            userId:getUserData().userId
                            
                        
                        }
                        
        

                        console.log("1111116666666");
                        console.log(newsContent)
                        console.log("1111116666666");
          
       
           
            const request = await axios.post(`${BASE_URL}api/news/ucontent`,newsContent,getAuthHeader());
            dispatch(successGlobal('Content Updated !!'))
           

            console.log(request.data);
           
            return request.data;
        } catch(error){
            dispatch(errorGlobal(error.response.data.message))
           // console.log("1000000000000000000");
            //console.log(error.response.data);
            console.log("333333333333333333333");
            throw error
        }
    }

)

